import { createMachine, EventObject } from 'xstate'

import { getUUIDv4 } from '@js/common/utils'

import {
  ConversionType,
  QuizConfig,
  QuizStep
} from '@f/applications/QuizApp/partials/types'
import { actions } from '@f/applications/QuizApp/stateMachine/actions'
import { guards } from '@f/applications/QuizApp/stateMachine/guards'
import { states } from '@f/applications/QuizApp/stateMachine/states'

import { getHashParams } from '@f-fertighaus/utils/hashParams'

import { MID_STEP_LOADER_APPEARANCE_TIME } from '../partials/quizConstants'

export interface QuizMachineContext {
  conversionType: ConversionType
  currentStepIndex: number
  visitedStepsAmount: number
  steps: QuizStep[]
  flow: {
    flow_information: {
      flow_id: string
      flow_type: string
      flow_kickoff: string[]
      flow_step: number
    }
  }
  exclusiveVendorNid?: string
  successRedirectPageUrl?: string
  displayLoader: boolean
  displayStep: boolean
}

interface NextStepEvent extends EventObject {
  type: 'NEXT_STEP'
}

interface PrevStepEvent extends EventObject {
  type: 'PREV_STEP'
}

interface SubmitEvent extends EventObject {
  type: 'SUBMIT'
}

export type QuizEvents = NextStepEvent | PrevStepEvent | SubmitEvent

export const initializeQuizMachine = (quizConfig: QuizConfig) => {
  const hashParams = getHashParams(window.location.hash)
  const isFirstQuestionPrefilled = hashParams.q?.match(/1-1|1-2|1-3|1-4/)

  return createMachine<QuizMachineContext, QuizEvents>(
    {
      predictableActionArguments: true,
      initial: 'pre-checkout',
      states: states,
      context: {
        conversionType: quizConfig.conversionType,
        currentStepIndex: isFirstQuestionPrefilled ? 1 : 0,
        visitedStepsAmount: isFirstQuestionPrefilled ? 2 : 1,
        steps: quizConfig.steps,
        flow: {
          flow_information: {
            flow_id: hashParams.fi || getUUIDv4(),
            flow_type: quizConfig.flowType,
            flow_kickoff: hashParams.fk ? [hashParams.fk] : [],
            flow_step: isFirstQuestionPrefilled ? 2 : 1
          }
        },
        exclusiveVendorNid: quizConfig.exclusiveVendorNid,
        successRedirectPageUrl: quizConfig.successRedirectPageUrl,
        displayLoader: false,
        displayStep: true
      }
    },
    {
      actions,
      guards,
      delays: {
        MID_STEP_LOADER_APPEARANCE_TIME
      }
    }
  )
}
